import { render, staticRenderFns } from "./device029-f-rgbw.vue?vue&type=template&id=5a089bf2&"
import script from "./device029-f-rgbw.vue?vue&type=script&lang=js&"
export * from "./device029-f-rgbw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports